/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import{f as s}from"../../../../chunks/vec3f64.js";class t{constructor(s,t){this.vec3=s,this.id=t}}function c(c,r,n,o){return new t(s(c,r,n),o)}export{t as LocalOrigin,c as fromValues};
